import { DateRange } from 'react-day-picker';
import { toZonedTime } from 'date-fns-tz';

export const utcDateRangeToZoned = (
  dateRange: DateRange | undefined,
  timeZone: string
): DateRange | undefined => {
  if (!dateRange) {
    return undefined;
  }

  const from = dateRange.from
    ? toZonedTime(dateRange.from, timeZone)
    : undefined;
  const to = dateRange.to ? toZonedTime(dateRange.to, timeZone) : undefined;

  return { from, to };
};
